import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Pencil, Trash2, KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import RegisterUserDialog from '../../components/RegisterUserDialog';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminUsersView = ({ 
  users, 
  currentUserId, 
  editingUser, 
  setEditingUser, 
  onRefresh 
}) => {
  const [resendingId, setResendingId] = React.useState(null);

  const handleResendSetupLink = async (u) => {
    if (!window.confirm(`Renvoyer un lien de création de mot de passe à ${u.prenom} ${u.nom} (${u.email}) ?`)) return;
    try {
      setResendingId(u.id);
      const token = localStorage.getItem('token');
      const { data } = await axios.post(
        `${API_URL}/api/auth/resend-setup-link/${u.id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(data?.message || 'Lien envoyé');
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi du lien");
    } finally {
      setResendingId(null);
    }
  };

  const handleDeleteUser = async (u) => {
    if (!window.confirm(`Supprimer l'utilisateur ${u.prenom} ${u.nom} ?`)) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/api/users/${u.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Utilisateur supprimé');
      onRefresh();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur de suppression');
    }
  };

  return (
    <>
      <Card className="bg-white border-slate-200 rounded-3xl p-6 shadow-sm">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-xl font-bold" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Utilisateurs ({users.length})
            </CardTitle>
            <RegisterUserDialog onSuccess={onRefresh} />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {users.map((u) => (
              <div
                key={u.id}
                data-testid={`user-item-${u.id}`}
                className="flex items-center justify-between p-3 bg-slate-50 rounded-xl"
              >
                <div>
                  <div className="font-bold text-slate-900">
                    {u.prenom} {u.nom}
                  </div>
                  <div className="text-sm text-slate-500">{u.email}</div>
                </div>
                <div className="flex items-center gap-3">
                  <div className={`px-3 py-1 rounded-full text-sm font-bold ${
                    u.role === 'admin' ? 'bg-purple-100 text-purple-700' :
                    u.role === 'referent' ? 'bg-blue-100 text-blue-700' :
                    (u.role === 'animateur' || u.role === 'alliance' || u.role === 'Alliance') ? 'bg-emerald-100 text-emerald-700' :
                    'bg-amber-100 text-amber-700'
                  }`}>
                    {u.role === 'animateur' || u.role === 'alliance' || u.role === 'Alliance' ? 'Intervenant' : 
                     u.role === 'admin' ? 'Administrateur' :
                     u.role === 'referent' ? 'Référent' :
                     u.role === 'financeur' ? 'Financeur' : u.role}
                  </div>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleResendSetupLink(u)}
                    disabled={resendingId === u.id}
                    className="rounded-xl border-blue-200 text-blue-600 hover:bg-blue-50"
                    title="Renvoyer le lien de création de mot de passe"
                    data-testid={`resend-setup-${u.id}`}
                  >
                    <KeyRound className="w-4 h-4" />
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => setEditingUser(u)}
                    className="rounded-xl"
                    data-testid={`edit-user-${u.id}`}
                  >
                    <Pencil className="w-4 h-4" />
                  </Button>
                  {u.id !== currentUserId && (
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => handleDeleteUser(u)}
                      className="rounded-xl border-red-200 text-red-600 hover:bg-red-50"
                      data-testid={`delete-user-${u.id}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Dialog d'édition */}
      {editingUser && (
        <RegisterUserDialog 
          editUser={editingUser} 
          onSuccess={onRefresh} 
          onClose={() => setEditingUser(null)}
        />
      )}
    </>
  );
};

export default AdminUsersView;
